import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function Topbar() {
  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (!token || token.trim() === "") {
      navigate("/login");
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const titles = {
    "/number": "MOBILE NUMBER REPORT",
    "/template": "TEMPLATE WISE REPORT",
    "/email-monitoring": "EMAIL MONITORING REPORT",
    "/subject-wise-report": "SUBJECT WISE REPORT",
    "/traffic": "TRAFFIC SUMMARY REPORT",
    "/failure": "FAILURE ANALYSIS REPORT",
    "/emailSubjectWiseReport": "EMAIL SUBJECT WISE SUMMARY",
    "/emailSummary": "EMAIL SUMMARY",
  };

  const currentTitle = titles[location.pathname] || " ";

  return (
    <header className="flex h-20 items-center border-b border-slate-200 bg-white px-6 shadow-sm justify-between">
      <div className="flex text-center">
        <p className="text-xl font-extrabold uppercase tracking-[0.25em] 
  bg-gradient-to-r from-slate-900 via-blue-700 to-cyan-500 
  bg-clip-text text-transparent 
  drop-shadow-sm">
          Hyundai Monitoring
        </p>
      </div>

      <div className="flex items-center gap-4">
        <span className="text-l font-bold text-slate-700">
          {currentTitle}
        </span>
      </div>


      <div className="flex items-center gap-3">
        <button className="inline-flex items-center gap-2 px-2 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-200">
          <span className="text-lg">👤</span>
        </button>
        <button
          type="button"
          onClick={handleLogout}
          className="inline-flex items-center gap-2 px-2 py-1 text-sm font-semibold text-black transition hover:bg-slate-200"
        >
          Logout
        </button>
      </div>
    </header>
  );
}

export default Topbar;
